import { render, staticRenderFns } from "./TablaDetallesListaCostosConvenio.vue?vue&type=template&id=67cf0746&scoped=true"
import script from "./TablaDetallesListaCostosConvenio.vue?vue&type=script&lang=js"
export * from "./TablaDetallesListaCostosConvenio.vue?vue&type=script&lang=js"
import style0 from "./TablaDetallesListaCostosConvenio.vue?vue&type=style&index=0&id=67cf0746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cf0746",
  null
  
)

export default component.exports